export default {
  // =============================================================================
  // USER LAYOUT ROUTES
  // =============================================================================
  path: '/',
    component: () => import('../layouts/Main.vue'),
  meta: { role: ['teacher', 'student'] },
  children: [
    {
      path: '',
      name: 'home',
      component: () => import('../views/Home.vue'),
      meta: { role: ['teacher', 'student'] },
    },

    {
      path: 'chat',
      name: 'chat',
      component: () => import('../views/chat/Chat.vue'),
      meta: { role: ['teacher', 'student'] },
    },

    {
      path: 'chat/:user_id',
      name: 'chatUser',
      component: () => import('../views/chat/Chat.vue'),
      meta: { role: ['teacher', 'student'] },
    },

    {
      path: 'profile',
      component: () => import('../views/profile/Profile.vue'),
      meta: {
        parent: '',
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'الصفحة الشخصية', active: true},
        ],
        pageTitle: 'الصفحة الشخصية',
        role: ['teacher', 'student']
      },
    },

    {
      path: 'profile/:user_id',
      name: 'profile',
      component: () => import('../views/profile/Profile.vue'),
      meta: {
        parent: '',
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'الصفحة الشخصية', active: true},
        ],
        pageTitle: 'الصفحة الشخصية',
        role: ['teacher', 'student']
      },
    },

    {
      path: 'calendar',
      name: 'calendar',
      component: () => import('../views/calendar/Calendar.vue'),
      meta: { role: ['teacher', 'student'] },
    },

    {
      path: 'questionsbank',
      name: 'questionsBank',
      component: () => import('../views/questionBanks/QuestionBanks.vue'),
      meta: { role: ['teacher'] },
    },

    // {
    //   path: 'enroll_courses',
    //   name: 'enrollCourses',
    //   component: () => import('../views/EnrollCourses.vue'),
    //   meta: {
    //     parent: '',
    //     breadcrumb: [
    //       { title: 'Home', url: '/' },
    //       { title: 'التسجيل في المقررات الدراسية', active: true},
    //     ],
    //     pageTitle: 'التسجيل في المقررات الدراسية',
    //     role: ['student']
    //   },
    // },

    /*============ Courses Pages ============*/
    {
      path: 'courses/:course_id',
      component: () => import('../layouts/Course.vue'),
      children: [
        {
          path: '',
          name: 'courseHome',
          component: () => import('../views/course/Home.vue'),
          meta: {
            parent: "Courses",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', active: true},
            ],
            pageTitle: 'صفحة المادة الرئيسية',
            backButton: true,
            role: ['teacher', 'student']
          },
        },
        {
          path: 'lectures',
          name: 'courseLectures',
          component: () => import('../views/course/lectures/Lectures.vue'),
          meta: {
            parent: "Courses",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', url: './' },
              { title: 'المحاضرات', active: true },
            ],
            pageTitle: 'المحاضرات',
            backButton: true,
            role: ['teacher', 'student']
          },
        },
        {
          path: 'assignments',
          name: 'courseAssignments',
          component: () => import('../views/course/assignments/Assignments.vue'),
          meta: {
            parent: "Courses",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', url: './'},
              { title: 'الواجبات', active: true },
            ],
            pageTitle: 'الواجبات',
            backButton: true,
            role: ['teacher', 'student']
          },
        },

        {
          path: 'quizzes',
          name: 'courseQuizzes',
          component: () => import('../views/course/quizzes/Quizzes.vue'),
          meta: {
            parent: "Courses",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', url: './'},
              { title: 'الإختبارات', active: true },
            ],
            pageTitle: 'الإختبارات',
            backButton: true,
            role: ['teacher', 'student']
          },
        },
        {
          path: 'students',
          name: 'courseStudents',
          component: () => import('../views/course/CourseStudents.vue'),
          meta: {
            parent: "Courses",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', url: './'},
              { title: 'الطلبة', active: true },
            ],
            pageTitle: 'الطلبة',
            backButton: true,
            role: ['teacher']
          },
        },
        {
          path: 'gradebook',
          name: 'courseGradebook',
          component: () => import('../views/course/Gradebook.vue'),
          meta: {
            parent: "Courses",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', url: './'},
              { title: 'دفتر الدرجات', active: true },
            ],
            pageTitle: 'دفتر الدرجات',
            backButton: true,
            role: ['teacher']
          },
        },
        {
          path: 'discussions',
          name: 'courseDiscussions',
          component: () => import('../views/course/discussions/Discussions.vue'),
          meta: {
            parent: "discussions",
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'صفحة المادة الرئيسية', url: './'},
              { title: 'النقاشات', active: true },
            ],
            pageTitle: 'النقاشات',
            backButton: true,
            role: ['teacher', 'student']
          },
        },
      ]
    },
    {
      path: 'courses/:course_id/lectures/:lecture_id',
      name: 'courseLecture',
      component: () => import('../views/course/lectures/Lecture.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../'},
          { title: 'المحاضرات', url: './'},
          { title: 'تفاصيل المحاضرة', active: true },
        ],
        pageTitle: 'تفاصيل المحاضرة',
        backButton: true,
        role: ['teacher', 'student']
      },
    },
    {
      path: 'courses/:course_id/quizzes/:quiz_id',
      name: 'courseQuiz',
      component: () => import('../views/course/quizzes/Quiz.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../'},
          { title: 'الإختبارات', url: './'},
          { title: 'الاختبار', active: true },
        ],
        pageTitle: 'الاختبار',
        backButton: true,
        role: ['student']
      },
    },
    {
      path: 'courses/:course_id/quizzes/:quiz_id/details',
      name: 'courseQuizDetails',
      component: () => import('../views/course/quizzes/QuizDetails.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../../'},
          { title: 'الإختبارات', url: './../'},
          { title: 'الاختبار', active: true },
        ],
        pageTitle: 'الاختبار',
        backButton: true,
        role: ['teacher']
      },
    },
    {
      path: 'courses/:course_id/quizzes/:quiz_id/result',
      name: 'courseQuizResult',
      component: () => import('../views/course/quizzes/QuizResult.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../../'},
          { title: 'الإختبارات', url: './../'},
          { title: 'الاختبار', active: true },
        ],
        pageTitle: 'الاختبار',
        backButton: true,
        role: ['student']
      },
    },
    {
      path: 'courses/:course_id/quizzes/:quiz_id/preview',
      name: 'courseQuizPreview',
      component: () => import('../views/course/quizzes/Quiz.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../../'},
          { title: 'الإختبارات', url: './../'},
          { title: 'تفاصيل الاختبار', active: true },
        ],
        pageTitle: 'تفاصيل الاختبار',
        backButton: true,
        role: ['teacher']
      },
    },
    {
      path: 'courses/:course_id/quizzes/:quiz_id/correction',
      name: 'courseQuizCorrection',
      component: () => import('../views/course/quizzes/correction/QuizCorrection.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../../'},
          { title: 'الإختبارات', url: './../'},
          { title: 'تصحيح الاختبار', active: true },
        ],
        pageTitle: 'تصحيح الاختبار',
        backButton: true,
        role: ['teacher']
      },
    },

    {
      path: 'courses/:course_id/assignments/:assignment_id',
      name: 'assignment',
      component: () => import('../views/course/assignments/Assignment.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../'},
          { title: 'الواجبات', url: './'},
          { title: 'الواجب', active: true },
        ],
        pageTitle: 'الواجب',
        backButton: true,
        role: ['student']
      },
    },
    {
      path: 'courses/:course_id/assignments/:assignment_id/result',
      name: 'assignmentResult',
      component: () => import('../views/course/assignments/AssignmentResult.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../../'},
          { title: 'الواجبات', url: './../'},
          { title: 'نتيجة الواجب', active: true },
        ],
        pageTitle: 'نتيجة الواجب',
        backButton: true,
        role: ['student']
      },
    },

    {
      path: 'courses/:course_id/assignments/:assignment_id/correction',
      name: 'assignmentCorrection',
      component: () => import('../views/course/assignments/correction/AssignmentCorrection.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../../'},
          { title: 'الواجبات', url: './../'},
          { title: 'تصحيح الواجب', active: true },
        ],
        pageTitle: 'تصحيح الواجب',
        backButton: true,
        role: ['teacher']
      },
    },

    {
      path: 'courses/:course_id/question_banks',
      name: 'courseQuestionBanks',
      component: () => import('../views/course/questionBanks/QuestionBanks.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../'},
          { title: 'بنوك الأسئلة', active: true },
        ],
        pageTitle: 'بنوك الأسئلة',
        backButton: true,
        role: ['student']
      },
    },

    {
      path: 'courses/:course_id/question_banks/:question_bank_id',
      name: 'courseQuestionBank',
      component: () => import('../views/course/questionBanks/QuestionBank.vue'),
      meta: {
        parent: "Courses",
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'صفحة المادة الرئيسية', url: './../'},
          { title: 'بنوك الأسئلة', url: './'},
          { title: 'بنك الأسئلة', active: true },
        ],
        pageTitle: 'بنك الأسئلة',
        backButton: true,
        role: ['student']
      },
    },
  ],
}
